const LOGIN_NOTICE_KEY = 'complytradeiq-login-notice';

export function storeLoginNotice(message) {
  if (!message || typeof window === 'undefined') return;
  window.sessionStorage.setItem(LOGIN_NOTICE_KEY, message);
}

export function consumeLoginNotice() {
  if (typeof window === 'undefined') return null;
  const message = window.sessionStorage.getItem(LOGIN_NOTICE_KEY);
  if (message) {
    window.sessionStorage.removeItem(LOGIN_NOTICE_KEY);
  }
  return message;
}

export function clearLoginNotice() {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(LOGIN_NOTICE_KEY);
}

export async function redirectToLogin(message) {
  storeLoginNotice(message);
  if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
}
